/* eslint-disable camelcase */
import { useParams } from 'react-router-dom';
import { useEffect, useRef, useCallback } from 'react';
import * as Pioneer from 'pioneer';

import { useSnapshot } from 'valtio';
import { stellarStore,cameraStore } from '../managers/globalState';

import ENTITY_INFO from '../data/entity_info.json';
import globalRefs from '../managers/globalRefs';
import { hideLoading, showLoading } from '../components/loading';

const StellarDetail = () => {
  const { pioneer, getManager } = globalRefs;
	const { stellarParam } = useParams();
	const isLoading = useRef(null);
	// console.log("StellarDetail: loading", stellarParam)
	const currentStellar = ENTITY_INFO[stellarParam]

	// useEffect for when event changes.
	useEffect(() => {
		// Set variables.
		const { pioneer } = globalRefs;
		const alreadyLoading = isLoading.current === stellarParam;

		if (!currentStellar || alreadyLoading) {
			return;
		}

		// Set isLoading.
		isLoading.current = stellarParam;

		// Show loading.
		const loadType = 'stellar';
		showLoading(loadType);

		// console.log("StellarDetail", currentStellar)
    window.addEventListener("mousedown", onClick);

		// Set current event in global state.
		stellarStore.setGlobalState({ currentStellar });
    
		return () => {
      window.removeEventListener("mousedown", onClick);
		};
	}, [currentStellar]);

	// useEffect to set current event to null and disable patch when leaving event detail view.
	// eslint-disable-next-line arrow-body-style
	useEffect(() => {
		return () => {
			const { pioneer, getManager } = globalRefs;
			// Set isLoading to null and hide loading.
			isLoading.current = null;
			hideLoading('stellar');

			// Disable the patch.
			// patchComponent.setEnabled(false);

			// Reset global states.
			stellarStore.setGlobalState({ currentStellar: null });

		};
	}, []);

  const onClick = useCallback((e) => {
    const { isCameraTransitioning } = cameraStore.stateSnapshot;
    // console.log("transitioning?", isCameraTransitioning)
    if (isCameraTransitioning) {
      return;
    }
    const normalSpacePosition = new Pioneer.Vector3();
    const pickDirection = new Pioneer.Vector3();
    const camera = pioneer.getScene('main').getEntity('camera').getComponent(Pioneer.CameraComponent);
    const pixelSpaceCursorPosition = camera.getViewport().getEngine().getInput().getCursorPosition();
    camera.getViewport().getNormalSpacePositionFromPixelSpacePosition(normalSpacePosition, pixelSpaceCursorPosition);
    camera.getCameraSpacePositionFromNormalSpacePosition(pickDirection, normalSpacePosition);
    pickDirection.normalize(pickDirection);
    const result = camera.getNearestIntersectingEntity(pickDirection);
    if(result && result._name != stellarParam){
      // console.log("navigate to", result._name, stellarParam)
      getManager('route').navigateToStellarBody(result._name);
    }
  }, [stellarParam]);


	return null;
};

export default StellarDetail;
